module.exports = __webpack_public_path__ + "img/customerService-code.9505c17d.png";